import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Potsdam() {
  return (
    <LocationPageTemplate
      page={{
        location: "Potsdam",
        locationSlug: "potsdam",
        keyword: "Haushaltsauflösung Potsdam",
        metaTitle:
          "Haushaltsauflösung Potsdam | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in Potsdam. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung anfragen!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Potsdam – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eebc08665f48fd4baa7.jpg",
        localIntro: (
          <>
            <p>
              Potsdam, die Landeshauptstadt Brandenburgs, grenzt direkt an den
              Südwesten Berlins und ist bekannt für ihre historischen Viertel,
              Schlösser und Gärten. Die Bebauung reicht von aufwendig sanierten
              Altbauten in der Innenstadt und Babelsberg bis hin zu weitläufigen
              Villenvierteln und modernen Wohnsiedlungen.
            </p>
            <p>
              Bei Entrümpelungen in Potsdam ist oft Fingerspitzengefühl gefragt,
              besonders wenn es um historische Gebäude oder wertvolle Nachlässe
              geht. Die logistischen Herausforderungen liegen oft in den engen
              Gassen der historischen Innenstadt oder bei der Räumung großer
              Grundstücke in den äußeren Bezirken.
            </p>
            <p>
              Wir sind regelmäßig in Potsdam im Einsatz und bieten Ihnen unseren
              bewährten Service: Von der kostenlosen Besichtigung bis zur
              besenreinen Übergabe, alles aus einer Hand und zum garantierten
              Festpreis.
            </p>
          </>
        ),
        trustText:
          "Ob eine Altbauwohnung in Babelsberg oder ein Haus in der Nauener Vorstadt – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Sehr gute Arbeit bei der Haushaltsauflösung in Potsdam. Pünktlich, sauber und genau zum vereinbarten Preis.",
        challengesText: (
          <>
            <p>
              In den historischen und dichter bebauten Bereichen Potsdams
              kümmern wir uns im Vorfeld um die Beantragung und Aufstellung von
              Halteverbotsschildern, um einen reibungslosen Abtransport zu
              gewährleisten und die Straßen nicht zu blockieren.
            </p>
            <p>
              Bei der Räumung von Villen oder Einfamilienhäusern sorgen wir für
              ausreichend Transportkapazität und kümmern uns um die fachgerechte
              Trennung und Entsorgung aller anfallenden Materialien auf den
              lokalen Recyclinghöfen.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Das Team hat unsere Wohnung in Babelsberg sehr schnell und ordentlich entrümpelt. Toller Service!",
            author: "Kunde aus Babelsberg",
          },
          {
            text: "Sehr freundlich und professionell. Die Wertanrechnung für einige Möbelstücke war sehr fair.",
            author: "Kundin aus der Innenstadt",
          },
          {
            text: "Alles wurde besenrein hinterlassen, genau wie versprochen. Keine versteckten Kosten.",
            author: "Familie aus Potsdam",
          },
        ],
        neighbors: [
          { name: "Steglitz-Zehlendorf", slug: "steglitz-zehlendorf" },
          { name: "Spandau", slug: "spandau" },
          { name: "Berlin", slug: "berlin" },
        ],
        faqs: [
          {
            q: "Kommen Sie für eine Besichtigung nach Potsdam?",
            a: "Ja, wir bieten kostenlose und unverbindliche Besichtigungstermine im gesamten Stadtgebiet Potsdams an.",
          },
          {
            q: "Beantragen Sie die Halteverbotszone in Potsdam selbst?",
            a: "Ja, wir kümmern uns um die komplette Abwicklung mit der Stadt Potsdam und stellen die Schilder rechtzeitig auf.",
          },
          {
            q: "Bieten Sie eine Wertanrechnung für Antiquitäten an?",
            a: "Ja, wir erkennen Wertgegenstände und rechnen diese transparent gegen die Kosten der Entrümpelung an.",
          },
          {
            q: "Wie lange dauert eine Haushaltsauflösung in der Regel?",
            a: "Eine normale Wohnungsauflösung ist oft an einem Tag erledigt. Bei größeren Häusern planen wir entsprechend mehr Zeit ein.",
          },
        ],
      }}
    />
  );
}
